// extracted by mini-css-extract-plugin
export var requiredMark = "required-mark_kzEVKaChYOCzpbZ8NxjV";